import type { CountryType, EnvType } from '@carrefour-gcs/shared';

const getEnv = (key: keyof ImportMetaEnv): string | undefined =>
  window.__RUNTIME_CONFIG__?.[key] ?? import.meta.env[key];

export const config = {
  baseUrl: import.meta.env.BASE_URL,
  apiRestBaseUrl: `${window.location.origin}/api`,
  appVersion: __APP_VERSION__,
  appEnv: getEnv('VITE_APP_ENV') as EnvType,
  devMode: getEnv('VITE_APP_ENV') === 'dev',
  gtm: {
    enabled: getEnv('VITE_APP_ENV') !== 'dev',
    id: getEnv('VITE_GTM_ID'),
    auth: getEnv('VITE_GTM_AUTH'),
    preview: getEnv('VITE_GTM_PREVIEW')
  },
  gtmProjects: {
    enabled: getEnv('VITE_APP_ENV') !== 'dev',
    debug: getEnv('VITE_APP_ENV') === 'dev',
    scriptUrl: getEnv('VITE_PROJECTS_GTM_SCRIPT_URL')
  },
  hubSpot: {
    portalId: getEnv('VITE_HUB_SPOT_PORTAL_ID'),
    formId: getEnv('VITE_HUB_SPOT_FORM_ID')
  },
  userflowToken: getEnv('VITE_USERFLOW_TOKEN'),
  tableau: {
    embeddingSdkUrl:
      getEnv('VITE_TABLEAU_EMBEDDING_SDK_URL') ??
      'https://eu-west-1a.online.tableau.com/javascripts/api/tableau.embedding.3.latest.min.js',
    marketShareDashboardUrl: getEnv('VITE_TABLEAU_MARKET_SHARE_DASHBOARD_URL')
  },
  productFruitsWorkspace: getEnv('VITE_PRODUCT_FRUITS_WORKSPACE'),
  innovationsUrl: getEnv('VITE_INNOVATIONS_URL'),
  login: {
    apiLoginPath: getEnv('VITE_API_LOGIN_PATH'),
    apiLogoutPath: getEnv('VITE_API_LOGOUT_PATH')
  },
  exportCsvDocUrl: {
    FRA: getEnv('VITE_EXPORT_DOC_URL_FRA'),
    ESP: getEnv('VITE_EXPORT_DOC_URL_ESP'),
    BEL: getEnv('VITE_EXPORT_DOC_URL_BEL')
  } as Record<CountryType, string>,
  deploy: {
    branch: getEnv('VITE_DEPLOY_BRANCH'),
    date: getEnv('VITE_DEPLOY_DATE'),
    commitSha: getEnv('VITE_DEPLOY_COMMIT_SHA')
  },
  newPermissionsManagementFeatureEnabled: getEnv('VITE_NEW_PM_ENABLED')
};
